export const workerCode: string = `
  self.onmessage = (event) => {
    const { options, query, chunkSize = 1000 } = event.data;

    const chunkArray = (arr, size) => {
      const chunks = [];
      for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
      }
      return chunks;
    };

    if (!options || options.length === 0) {
      self.postMessage({ results: [], done: true });
      return;
    }

    let filtered = options;
    if (query && query.length >= 3) {
      const lowerQuery = query.toLowerCase();
      filtered = options.filter((option) =>
        option.label.toLowerCase().includes(lowerQuery)
      );
    }

    const filteredChunks = chunkArray(filtered, chunkSize);
    if (filteredChunks.length === 0) {
      self.postMessage({ results: [], done: true });
      return;
    }

    filteredChunks.forEach((chunk, index) => {
      const isDone = index === filteredChunks.length - 1;
      self.postMessage({ results: chunk, done: isDone });
    });
  };
`;
